import AuditGrid from './audit-page';

export default function AuditPage() {
  return <AuditGrid />;
}
